﻿var $ = require('jquery');
var newdata = [];
var downloaddata = [];
var table2_rows_selected = [];
var totalNav = 0;
var totalPer = 0;
var totalPerCal = 0;
var totalDown = 0;
let that = this;
//$(window).scroll(function () {
//    var scroll = $(window).scrollTop();

//    if (scroll >= 800) {
//        $(".tablesection").addClass("tablenew-sticky");
//    } else {
//        $(".tablesection").removeClass("tablenew-sticky");
//    }
//});
$(document).ready(function () {

    var _loc = document.location.href;
    if (_loc.indexOf('/pages') != -1) {
        $('#loadtop-funds').hide();
    }


    totalNav = $('.th-search-fund').attr('nav-total');
    totalPer = $('.th-search-fund').attr('per-total');
    totalPerCal = $('.th-search-fund').attr('per-cal-total');
    totalDown = $('.th-search-fund').attr('download-total');
    $('.fundsgridnav li a').click(function () {
        var tabid = $(this).attr('data-id');
        if (tabid == 'download-tablesection') {
            $('.download-section').show();
        }
        else {
            $('.download-section').hide();
        }

    });

    $(document).on('click', '.thai-lng-blk a', function () {
        $('.thai-lng-blk a').removeClass('active');
        $(this).addClass('active');
        var langCode = $(this).attr("data-lang");
        //$('.fund-listings-table-custom').hide();
        $('.docitem').hide();
        $('.docitem.' + langCode).show();
        //$($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();   
        //18-07-2019
        $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();

    });
    setTimeout(function () {
        $('#tablegrid .dt-checkboxes').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
            else {
                $(this).addClass('active');
            }
        });
        $('#pertablegrid .dt-checkboxes').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
            else {
                $(this).addClass('active');
            }
        });
        $('#devtablegrid .dt-checkboxes').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
            else {
                $(this).addClass('active');
            }
        });
        $('#downtablegrid .dt-checkboxes').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
            else {
                $(this).addClass('active');
            }
        });
    }, 1000);

    $(document).on("click", "#downtablegrid .dt-checkboxes", function () {
        // $('#downtablegrid .dt-checkboxes').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        }
        else {
            $(this).addClass('active');
        }
    });

    $('.moreless-button').click(function () {
        var rxr = $(this).attr('data-less');
        var actval = $(this).attr('data-actual');
        if (rxr == '- See less') {
            $(this).attr('data-less', '+ See more');

            $(this).text(rxr);
        }
        else {
            $(this).attr('data-less', '- See less');

            $(this).text(actval);
        }

    });
});
var counCookie = '';
var countryCode = "";
var prof = "";
var flag = false;
$('.tablesection').scroll(function () {
    if ($(this).scrollTop()) {
        $('.sticky').addClass('stickyss');
        setTimeout(function () {
            var res = $('.stickyss').length;
            if (res > 0 && flag == false) {
                flag = true;
                var topValue = $(window).scrollTop();
                var stickyItem = $('.listtable table.dataTable thead tr').height();
                $(window).scrollTop(topValue + stickyItem + 10000);
            }
        }, 9000);
    } else {
        $('.sticky').removeClass('stickyss');
    }
});

$(document).ready(function () {
    if (window.location.href.indexOf('/funds/mutual-funds') != -1 && $('#tablegrid').length > 0) {
        var tableOffset = $("#tablegrid").offset().top;
        var $header = $("#tablegrid > thead").clone();
        var $fixedHeader = $("#header-fixed").append($header);

        $(window).bind("scroll", function () {
            var offset = $(this).scrollTop();

            if (offset >= tableOffset && $fixedHeader.is(":hidden")) {
                $fixedHeader.show();
            }
            else if (offset < tableOffset) {
                $fixedHeader.hide();
            }
        });
    }
});
$(document).ready(function () {
    console.clear();
    var docloc = document.location.href;
    if (docloc.indexOf('mutual-funds') != -1 && $('#tablegrid').length > 0) {

        var token = $('input[name="__RequestVerificationToken"]').val();
        var tarurl = window.location.pathname + "/GetFunds_Data";
        var filterData = [];
        $.ajax({
            type: "POST",
            cache: false,
            dataType: "json",
            data: { __RequestVerificationToken: token },
            url: tarurl,
            // url: '/api/FundsApi/GetFunds_Data?__RequestVerificationToken=' + token,
            success: function (response) {
                filterData = response;
                //console.log(filterData.lstPerformance.length);
            },

            failure: function (response) {
            },

            complete: function () { }
        });

        var navlist = $('#tablegrid').DataTable({
            dom: 'rtp',
            order: false,
            scrollX: true,
            fixedHeader: true,
            searching: true,
            caseInsensitive: false,
            columns: [
                {
                    'targets': 0,
                    'data': 'FundCode',
                    'checkboxes': {
                        //'selectRow': true,
                        selectCallback: function selectCallback(node, selected) {
                            var table2_rows_selected = navlist.column(0).checkboxes.selected();
                            var watchListitems = '';
                            for (var i = 0; i < table2_rows_selected.length; i++) {
                                watchListitems = watchListitems + table2_rows_selected[i] + '|';
                            }
                            var expires = "max-age=" + 24 * 60 * 60 * 1 * 20;
                            if (watchListitems != '') {
                                if (watchListitems.indexOf('|') != -1) {
                                    watchListitems = watchListitems.substring(0, watchListitems.length - 1);

                                    if (window.location.href.indexOf('https') != -1)
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                    else
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                                }

                            }
                            else {
                                watchListitems = '';
                                if (window.location.href.indexOf('https') != -1)
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                else
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                            }
                        }
                    }
                },
                { 'targets': 1, data: 'FundName' },
                { 'targets': 2, data: 'MorningStar' },
                { 'targets': 3, data: 'NAVPerUnit' },
                { 'targets': 4, data: 'NAVDailyChange' },
                { 'targets': 5, data: 'PercentChange' },
                { 'targets': 6, data: 'NAV' },
                { 'targets': 7, data: 'Offer' },
                { 'targets': 8, data: 'Bid' },
                { 'targets': 9, data: 'PreviousNAV' },

                { 'targets': 10, 'data': 'AssetClass', visible: false },
                { 'targets': 11, 'data': 'Region', visible: false },
                { 'targets': 12, 'data': 'NewFund', visible: false },
                { 'targets': 13, 'data': 'Purpose', visible: false },
                { 'targets': 14, 'data': 'TopRated', visible: false },
                { 'targets': 15, 'data': 'TaxBenfit', visible: false },
                { 'targets': 16, 'data': 'InvestmentCategory', visible: false },
                { 'targets': 17, 'data': 'Keywords', visible: false },
                { 'targets': 18, 'data': 'Source', visible: false },
                { 'targets': 19, 'data': 'FundCode', visible: false },
                { 'targets': 20, 'data': 'FundName1', visible: false },
                { 'targets': 21, 'data': 'ShareClass', visible: false }
            ],
            oLanguage: {
                sInfoFiltered: ""
            },
            fixedColumns: {
                leftColumns: 2
            },
            scroller: {
                loadingIndicator: true
            },
            info: true,
            scrollCollapse: true,
            paging: false,
            //pageLength: 20,
            //fixedHeader: {
            //        header: true,
            //        headerOffset: $('#fixed').height()
            //    },
            scrollCollapse: true,
            scrollY: '200vh',
            initComplete: function () {
                var loc = document.location.href;
                if (loc.indexOf('#') != -1) {
                    var id = loc.split('#')[1];
                    id = decodeURIComponent(id);
                    if (id == 'fund-price-tab') {
                        id = 'nav-tablesection';
                    }
                    else if (id == 'performance-tab') {
                        id = 'performance-tablesection';
                    }
                    else if (id == 'int-composition-tab') {
                        id = 'dividend-tablesection';
                    }
                    else if (id == 'download') {
                        id = 'download-tablesection';
                    }
                    if (id.indexOf('tablesection') != -1) {
                        $('.tablesection').hide();
                        $(".fundsgridnav ul li a").removeClass('active');
                        $(".fundsgridnav ul li a[data-id='" + id + "']").addClass('active');
                        $('.' + id).show();
                    }
                    else {
                        id = id.replaceAll('-', ' ');
                        $(".styled-checkbox.investment[data-value='" + id + "']").prop("checked", true);
                        var id1 = $(".styled-checkbox.investment[data-value='" + id + "']").parent().parent();
                        if (id1.hasClass('moretext')) {
                            id1.show();
                            $(id1).parent().find('.moreless-button').attr('data-less', '+ See more');
                            $(id1).parent().find('.moreless-button').text('- See less');
                        }
                    }
                    setTimeout(function () {
                        $('.btn-fundsearch').trigger("click");
                    }, 1000);
                }

                $('#loadtop-funds').hide();
            }
        });
        var perlist = $('#pertablegrid').DataTable({
            dom: 'rtp',
            order: [],
            scrollX: true,
            fixedHeader: true,
            columns: [
                {
                    'targets': 0,
                    'data': 'FCode',
                    'checkboxes': {
                        //'selectRow': true,
                        selectCallback: function selectCallback(node, selected) {
                            var table2_rows_selected = navlist.column(0).checkboxes.selected();
                            var watchListitems = '';
                            for (var i = 0; i < table2_rows_selected.length; i++) {
                                watchListitems = watchListitems + table2_rows_selected[i] + '|';
                            }
                            var expires = "max-age=" + 24 * 60 * 60 * 1 * 20;
                            if (watchListitems != '') {
                                if (watchListitems.indexOf('|') != -1) {
                                    watchListitems = watchListitems.substring(0, watchListitems.length - 1);

                                    if (window.location.href.indexOf('https') != -1)
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                    else
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                                }

                            }
                            else {
                                watchListitems = '';
                                if (window.location.href.indexOf('https') != -1)
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                else
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                            }
                        }
                    }
                },
                {
                    'targets': 1,
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                { 'targets': 2, data: 'FundName' },
                { 'targets': 3, data: 'YTD' },
                { 'targets': 4, data: '3m' },
                { 'targets': 5, data: '6m' },
                { 'targets': 6, data: '1y' },
                { 'targets': 7, data: '3y' },
                { 'targets': 8, data: '5y' },
                { 'targets': 9, data: '10y' },
                { 'targets': 10, data: 'si' },
                { 'targets': 11, data: 'PreviousNAV' },

                { 'targets': 12, 'data': 'AssetClass', visible: false },
                { 'targets': 13, 'data': 'Region', visible: false },
                { 'targets': 14, 'data': 'NewFund', visible: false },
                { 'targets': 15, 'data': 'Purpose', visible: false },
                { 'targets': 16, 'data': 'TopRated', visible: false },
                { 'targets': 17, 'data': 'TaxBenfit', visible: false },
                { 'targets': 18, 'data': 'InvestmentCategory', visible: false },
                { 'targets': 19, 'data': 'Keywords', visible: false },
                { 'targets': 20, 'data': 'Source', visible: false },
                { 'targets': 21, 'data': 'FCode', visible: false },
                { 'targets': 22, 'data': 'ShareClass', visible: false }
            ],
            oLanguage: {
                sInfoFiltered: ""
            },
            fixedColumns: {
                leftColumns: 2
            },
            scroller: {
                loadingIndicator: true
            },
            info: true,
            scrollCollapse: true,
            paging: false,
            //pagelength: 20,
            // scrollCollapse: true,
            // scrollY: '200vh'
            scrollCollapse: true,
            scrollY: '200vh'

        });
        var devidendlist = $('#devtablegrid').DataTable({
            dom: 'rtp',
            order: [],
            scrollX: true,
            fixedHeader: true,
            columns: [

                {
                    'targets': 0,
                    'data': 'FCode',
                    'checkboxes': {
                        //'selectRow': true,
                        selectCallback: function selectCallback(node, selected) {
                            var table2_rows_selected = navlist.column(0).checkboxes.selected();
                            var watchListitems = '';
                            for (var i = 0; i < table2_rows_selected.length; i++) {
                                watchListitems = watchListitems + table2_rows_selected[i] + '|';
                            }
                            var expires = "max-age=" + 24 * 60 * 60 * 1 * 20;
                            if (watchListitems != '') {
                                if (watchListitems.indexOf('|') != -1) {
                                    watchListitems = watchListitems.substring(0, watchListitems.length - 1);

                                    if (window.location.href.indexOf('https') != -1)
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                    else
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                                }

                            }
                            else {
                                watchListitems = '';
                                if (window.location.href.indexOf('https') != -1)
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                else
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                            }
                        }
                    }
                },
                {
                    'targets': 1,
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                { 'targets': 2, data: 'FundName' },
                { 'targets': 3, data: 'fundCalVal1' },
                { 'targets': 4, data: 'fundCalVal2' },
                { 'targets': 5, data: 'fundCalVal3' },
                { 'targets': 6, data: 'fundCalVal4' },
                { 'targets': 7, data: 'fundCalVal5' },
                { 'targets': 8, data: 'fundCalVal6' },
                { 'targets': 9, data: 'fundCalVal7' },
                { 'targets': 10, data: 'fundCalVal8' },
                { 'targets': 11, data: 'fundCalVal9' },
                { 'targets': 12, data: 'fundCalVal10' },
                { 'targets': 13, 'data': 'AssetClass', visible: false },
                { 'targets': 14, 'data': 'Region', visible: false },
                { 'targets': 15, 'data': 'NewFund', visible: false },
                { 'targets': 16, 'data': 'Purpose', visible: false },
                { 'targets': 17, 'data': 'TopRated', visible: false },
                { 'targets': 18, 'data': 'TaxBenfit', visible: false },
                { 'targets': 19, 'data': 'InvestmentCategory', visible: false },
                { 'targets': 20, 'data': 'Keywords', visible: false },
                { 'targets': 21, 'data': 'Source', visible: false },
                { 'targets': 22, 'data': 'FCode', visible: false },
                { 'targets': 23, 'data': 'ShareClass', visible: false }
            ],
            oLanguage: {
                sInfoFiltered: ""
            },
            fixedColumns: {
                leftColumns: 2
            },
            scroller: {
                loadingIndicator: true
            },
            info: true,
            scrollCollapse: true,
            paging: false,
            //pagelength: 20,
            scrollCollapse: true,
            scrollY: '200vh'
        });

        var downloadlist = $('#downtablegrid').DataTable({
            dom: 'rtp',
            order: false,
            scrollX: true,
            fixedHeader: true,
            searching: true,
            caseInsensitive: false,
            'scrollX': true,
            'columnDefs': [
                {
                    'targets': 0,
                    'data': 'FundCode',
                    'checkboxes': {
                        //'selectRow': true,
                        selectCallback: function selectCallback(node, selected) {
                            var table2_rows_selected = navlist.column(0).checkboxes.selected();
                            var watchListitems = '';
                            for (var i = 0; i < table2_rows_selected.length; i++) {
                                watchListitems = watchListitems + table2_rows_selected[i] + '|';
                            }
                            var expires = "max-age=" + 24 * 60 * 60 * 1 * 20;
                            if (watchListitems != '') {
                                if (watchListitems.indexOf('|') != -1) {
                                    watchListitems = watchListitems.substring(0, watchListitems.length - 1);

                                    if (window.location.href.indexOf('https') != -1)
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                    else
                                        document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                                }

                            }
                            else {
                                watchListitems = '';
                                if (window.location.href.indexOf('https') != -1)
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
                                else
                                    document.cookie = "FavFunds=" + watchListitems + ";" + expires + ";path=/";
                            }
                        }
                    }
                },
                {
                    'targets': 1,
                    'data': 'FundName'
                },
                {
                    'targets': 2,
                    'sorting': false,
                    'data': 'Factsheetname'
                },
                {
                    'targets': 3,
                    'sorting': false,
                    'data': 'MasterFactsheetname'
                },
                {
                    'targets': 4,
                    'sorting': false,
                    'data': 'Portfolio'
                },
                {
                    'targets': 5,
                    'sorting': false,
                    'data': 'Prospectus'
                },
                {
                    'targets': 6,
                    'sorting': false,
                    'data': 'QA'
                },
                {
                    'targets': 7,
                    'data': 'FundInsight',
                    'sorting': false,
                },
                {
                    'targets': 8,
                    'data': 'HalfYearReport',
                    'sorting': false
                },
                {
                    'targets': 9,
                    'data': 'AnnualReport',
                    'sorting': false,
                },
                {
                    'targets': 10,
                    'data': 'InvestmentReport',
                    'sorting': false,
                },
                {
                    'targets': 11,
                    'data': 'FixDebtReport',
                    'sorting': false,
                },
                {
                    'targets': 12,
                    'data': 'MonthlyReport',
                    'sorting': false,
                },
                {
                    'targets': 13,
                    'data': 'OnePageSnapshot',
                    'sorting': false,
                },
                {
                    'targets': 14,
                    'data': 'Source',
                    visible: false,
                },
                {
                    'targets': 15,
                    visible: false,
                    'data': 'AssetClass'
                },
                {
                    'targets': 16,
                    visible: false,
                    'data': 'Region'
                },
                {
                    'targets': 17,
                    visible: false,
                    'data': 'TaxBenfit'
                },
                {
                    'targets': 18,
                    visible: false,
                    'data': 'TopRated'
                },
                {
                    'targets': 19,
                    visible: false,
                    'data': 'NewFund'
                },
                {
                    'targets': 20,
                    visible: false,
                    'data': 'Purpose'
                },
                {
                    'targets': 21,
                    visible: false,
                    'data': 'Keywords'
                },
                {
                    'targets': 22,
                    visible: false,
                    'data': 'FundCode'
                },
                {
                    'targets': 23,
                    visible: false,
                    'data': 'InvestmentCategory'
                },
                {
                    'targets': 24,
                    visible: false,
                    'data': 'ShareClass'
                }],
            oLanguage: {
                sInfoFiltered: ""
            },
            fixedColumns: {
                leftColumns: 2
            },
            scroller: {
                loadingIndicator: true
            },
            info: true,
            scrollCollapse: true,
            paging: false,
            //pageLength: 20,
            scrollCollapse: true,
            scrollY: '200vh'
        });
        var isfundDownloadloaded = false;
        var location = document.location.href;
        if (location.indexOf('#') != -1) {
            var download_id = location.split('#')[1];
            if (download_id.indexOf('download') != -1) {
                $('#loadtop-funds').show();
                setTimeout(function () {
                    var token = $('input[name="__RequestVerificationToken"]').val();
                    var tarurl = window.location.pathname + "/GetFunds_DownloadsData";
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        'async': false,
                        data: { __RequestVerificationToken: token },
                        url: tarurl,
                        // url: '/api/FundsApi/GetFunds_DownloadsData?__RequestVerificationToken=' + token,
                        success: function (data) {
                            downloaddata = data;
                            //console.log(data);
                            downloadlist.rows.add(data).draw(false);
                            isfundDownloadloaded = true;
                            var cnt = downloadlist['context'][0]['aiDisplay'].length;
                            $('.searchfunds').text('แสดงข้อมูลกองทุน ' + cnt + ' กองจาก ' + totalDown + ' กอง');
                            for (i = 0; i <= downloaddata.length; i++) {
                                if (downloaddata[i] != undefined) {
                                    var _fname = downloaddata[i].FundName;
                                    if (_fname.indexOf('<a ') != -1) {
                                        _fname = $(_fname).text();
                                    }
                                    $(".grid-prod-download").append(
                                        //
                                        $('<div class="prod-grid" data-fundcode=' + downloaddata[i].FundCode + ' data-fundname=' + downloaddata[i].FundName + ' data-source=' + downloaddata[i].Source + ' data-region=' + downloaddata[i].Region + ' data-purpose=' + downloaddata[i].Purpose + ' data-taxbenfit=' + downloaddata[i].TaxBenfit + ' data-newfund=' + downloaddata[i].NewFund + ' data-toprated=' + downloaddata[i].TopRated + ' data-keywords=' + downloaddata[i].Keywords + ' data-investmentcategory=' + downloaddata[i].InvestmentCategory + ' data-investment=' + downloaddata[i].InvestmentCategory + ' data-share=' + downloaddata[i].ShareClass + '>' +
                                            '<p class="fund-name">' + downloaddata[i].FundName + '</p>  <hr class="borderstyle">' +
                                            '<ul class="square">' +
                                            '<li>' + downloaddata[i].Factsheetname + '</li>' +
                                            '<li>' + downloaddata[i].MasterFactsheetname + '</li>' +
                                            '<li>' + downloaddata[i].Portfolio + '</li>' +
                                            '<li>' + downloaddata[i].Prospectus + '</li>' +
                                            '<li>' + downloaddata[i].QA + '</li>' +
                                            '<li>' + downloaddata[i].FundInsight + '</li>' +
                                            '<li>' + downloaddata[i].HalfYearReport + '</li>' +
                                            '<li>' + downloaddata[i].AnnualReport + '</li>' +
                                            '<li>' + downloaddata[i].InvestmentReport + '</li>' +
                                            '<li>' + downloaddata[i].FixDebtReport + '</li>' +
                                            '<li>' + downloaddata[i].MonthlyReport + '</li>' +
                                            '<li>' + downloaddata[i].OnePageSnapshot + '</li>' +
                                            '</ul>' +
                                            '</div>'

                                        ));
                                }
                            }
                            $('#loadtop-funds').hide();
                            $('#downtablegrid .dt-checkboxes').click(function () {
                                if ($(this).hasClass('active')) {
                                    $(this).removeClass('active');
                                }
                                else {
                                    $(this).addClass('active');
                                }
                            });
                            /*$('.btn-fundsearch').trigger("click");*/
                        },
                        error: function () {
                            $('#loadtop-funds').hide();
                        },
                        complete: function () {
                            $('#loadtop-funds').hide();
                        }

                    });
                }, 500);

            }


        }
        function sortByKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        }
        function format(d) {
            d = sortByKey(d, 'listOrder');
            //console.log(d);
            var retval = '';
            for (var i = 0; i < d.length; i++) {
                var trClass = '';
                if (i == 0) {
                    trClass = 'tr-td-2';
                }
                console.log(d[i]);
                retval = retval + '<tr>' +
                    '<td></td>' +
                    '<td></td>' +
                    '<td class="' + d[i].FCode + ' ' + trClass + '"><a href="/funds/mutual-funds/funddetails?fundcode=' + d[i].FCode + '">' + d[i].FundName + '</a>';
                if (d[i].isSD == false && d[i].FundName.indexOf('Track') == -1) {
                    console.log('3');
                    retval = retval + '<img loading="lazy" class="graph-icon-benchmark" src="/Sitefinity/WebsiteTemplates/TH_Base/App_Themes/TH_Base/Global/images/remark-no-type-9.png" data-navcode="' + d[i].FCode + '" data-navtype="tab-Navtabprice">';
                }


                var bmdt = d[i].BM_Date;
                if (bmdt.indexOf('Date') != -1) {
                    bmdt = bmdt.replace('/', '').replace('/', '').replace('Date', '').replace('(', '').replace(')', '');
                    const event = new Date(parseInt(bmdt));
                    const oneDayInMillis = 24 * 60 * 60 * 1000;
                    const newDate = new Date(event.getTime() + oneDayInMillis);
                    const options = { day: 'numeric', month: 'short', year: 'numeric' };

                    var dt = newDate.toLocaleDateString('th-TH', options);

                    retval = retval + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].YTD + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_3M + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_6M + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_1Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_3Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_5Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_10Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].si + '</td>' +
                        '<td class="' + d[i].FCode + '">' + dt + '</td>' +
                        '</tr>';
                }
                else {
                    retval = retval + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].YTD + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_3M + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_6M + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_1Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_3Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_5Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].Bid_To_Bid_10Y + '</td>' +
                        '<td class="' + d[i].FCode + '">' + d[i].si + '</td>' +
                        '<td class="' + d[i].FCode + '">-</td>' +
                        '</tr>';
                }





            }
            return (retval);

        }
        function formatDiv(d) {
            d = sortByKey(d, 'listOrder');
            // console.log(d);
            var retval = '';
            for (var i = 0; i < d.length; i++) {

                var fname = '';

                if (d[i].FundCategory == 17)
                    fname = d[i].FullFundName;
                else
                    fname = d[i].FundName;

                var SecondaryName = '';
                if (d[i].SecondaryName.length > 0) {
                    SecondaryName = ' (' + d[i].SecondaryName + ' )';
                }

                var trClass = '';
                if (i == 0) {
                    trClass = 'tr-td-2';
                }
                retval = retval + '<tr>' +
                    '<td></td>' +
                    '<td></td>' +
                    //onclick="javascript:GTMTagCustomClick_fund(' + fname + '","/funds/mutual-funds/funddetails?fundcode=' + d[i].FCode + '","fund","fund-listings-Performance-Calendar");"
                    '<td class="' + d[i].FCode + ' ' + trClass + '"><a href="/funds/mutual-funds/funddetails?fundcode=' + d[i].FCode.replace("+", "%20") + '">' + fname + SecondaryName + '</a>';
                if (d[i].isSD == false && i != 0) {
                    retval = retval + '<img loading="lazy" class="graph-icon-benchmark" src="/Sitefinity/WebsiteTemplates/TH_Base/App_Themes/TH_Base/Global/images/remark-no-type-9.png" data-navcode="' + d[i].FCode + '" data-navtype="tab-Navtabprice">';
                }
                retval = retval + '</td>';
                if (d[i].Source == 'TFund') {

                    if (d[i].fundCalVal1 != "0.00%" && d[i].fundCalVal1 != "-" && d[i].fundCalVal1 != "0.0" && d[i].fundCalVal1 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal1 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal2 != "0.00%" && d[i].fundCalVal2 != "-" && d[i].fundCalVal2 != "0.0" && d[i].fundCalVal2 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal2 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal3 != "0.00%" && d[i].fundCalVal3 != "-" && d[i].fundCalVal3 != "0.0" && d[i].fundCalVal3 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal3 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal4 != "0.00%" && d[i].fundCalVal4 != "-" && d[i].fundCalVal4 != "0.0" && d[i].fundCalVal4 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal4 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal5 != "0.00%" && d[i].fundCalVal5 != "-" && d[i].fundCalVal5 != "0.0" && d[i].fundCalVal5 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal5 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal6 != "0.00%" && d[i].fundCalVal6 != "-" && d[i].fundCalVal6 != "0.0" && d[i].fundCalVal6 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal6 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal7 != "0.00%" && d[i].fundCalVal7 != "-" && d[i].fundCalVal7 != "0.0" && d[i].fundCalVal7 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal7 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal8 != "0.00%" && d[i].fundCalVal8 != "-" && d[i].fundCalVal8 != "0.0" && d[i].fundCalVal8 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal8 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal9 != "0.00%" && d[i].fundCalVal9 != "-" && d[i].fundCalVal9 != "0.0" && d[i].fundCalVal9 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal9 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal10 != "0.00%" && d[i].fundCalVal10 != "-" && d[i].fundCalVal10 != "0.0" && d[i].fundCalVal10 != "") {
                        retval = retval + '<td>' + d[i].fundCalVal10 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                }
                else {
                    if (d[i].fundCalVal1 != '' && d[i].fundCalVal1.length != -1 && d[i].fundCalVal1 != "null" && d[i].fundCalVal1 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal1 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal2 != '' && d[i].fundCalVal2.length != -1 && d[i].fundCalVal2 != "null" && d[i].fundCalVal2 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal2 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal3 != '' && d[i].fundCalVal3.length != -1 && d[i].fundCalVal3 != "null" && d[i].fundCalVal3 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal3 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal4 != '' && d[i].fundCalVal4.length != -1 && d[i].fundCalVal4 != "null" && d[i].fundCalVal4 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal4 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal5 != '' && d[i].fundCalVal5.length != -1 && d[i].fundCalVal5 != "null" && d[i].fundCalVal5 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal5 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal6 != '' && d[i].fundCalVal6.length != -1 && d[i].fundCalVal6 != "null" && d[i].fundCalVal6 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal6 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal7 != '' && d[i].fundCalVal7.length != -1 && d[i].fundCalVal7 != "null" && d[i].fundCalVal7 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal7 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal8 != '' && d[i].fundCalVal8.length != -1 && d[i].fundCalVal8 != "null" && d[i].fundCalVal8 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal8 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal9 != '' && d[i].fundCalVal9.length != -1 && d[i].fundCalVal9 != "null" && d[i].fundCalVal9 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal9 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                    if (d[i].fundCalVal10 != '' && d[i].fundCalVal10.length != -1 && d[i].fundCalVal10 != "null" && d[i].fundCalVal10 != "-") {
                        retval = retval + '<td>' + d[i].fundCalVal10 + '</td>';
                    }
                    else {
                        retval = retval + '<td>N/A</td>';
                    }
                }

            }
            return (retval);

        }
        $('#pertablegrid tbody').on('click', 'td.dt-control', function () {
            var selectedFcode = $(this).attr('data-Fcode');
            var tr = $(this).closest('tr');
            var row = perlist.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                tr.removeClass('dt-hasChild');
            } else {
                var data_filter = filterData.lstPerformance.filter(element => element.FCode == selectedFcode);
                row.child($(format(data_filter))).show();
                tr.addClass('shown');
                tr.addClass('dt-hasChild');
            }
        });

        $('#devtablegrid tbody').on('click', 'td.dt-control', function () {
            debugger;
            var selectedFcode = $(this).attr('data-Fcode');
            var tr = $(this).closest('tr');
            var row = devidendlist.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                tr.removeClass('dt-hasChild');
            } else {
                var data_filter = filterData.lstPerformanceCalendarYear.filter(element => element.FCode == selectedFcode);
                row.child($(formatDiv(data_filter))).show();
                tr.addClass('shown');
                tr.addClass('dt-hasChild');
            }
        });

        $('.styled-checkbox').change(function () {
            $('.btn-fundsearch').trigger("click");
        });
        $(document).on('click', '.btn-fundsearch', function (e) {

            navlist.CaseSensitive = false;
            var val = $('.search-text').val();
            if (val.length > 0) {
                navlist.search(val).draw();
                perlist.search(val).draw();
                devidendlist.search(val).draw();
                downloadlist.search(val).draw();
            }

            var asset = '', region = '', newFund = '', purpose = '', toprated = '', taxbenfit = '', keywords = '', investment = '', source = '', FundCode = '', share = '';
            $('.styled-checkbox').each(function () {
                if (this.checked && $(this).hasClass("asset")) {
                    asset = asset + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("source")) {
                    source = source + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("country")) {
                    region = region + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("geo-focus")) {
                    purpose = purpose + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("currency")) {
                    taxbenfit = taxbenfit + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("investment")) {
                    investment = investment + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("toprated")) {
                    toprated = toprated + $(this).attr('data-value');
                }
                if (this.checked && $(this).hasClass("newfund")) {
                    newFund = newFund + $(this).attr('data-value');
                }
                if (this.checked && $(this).hasClass("shareclass")) {
                    share = share + $(this).attr('data-value') + '|';
                }
                if (this.checked && $(this).hasClass("watchlist")) {
                    var name = "FavFunds";
                    var ca = document.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') c = c.substring(1);
                        if (c.indexOf(name) == 0) FundCode = c.substring(name.length, c.length);
                    }

                }
            });
            //console.log(FundCode);
            var totalitems = $('.prod-grid');


            if (asset.indexOf('|') != -1) {
                asset = asset.substring(0, asset.length - 1);
                //divfilter = divfilter + '[data-asset="' + asset + '"]';
                totalitems = totalitems.filter(function () {
                    var data = $(this).data('asset');
                    return data ? data.match(asset) : null;
                });
            }
            else
                asset = '';

            if (source.indexOf('|') != -1) {
                source = source.substring(0, source.length - 1);
                //divfilter = divfilter + '[data-asset="' + asset + '"]';
                totalitems = totalitems.filter(function () {
                    var data = $(this).data('source');
                    return data ? data.match(source) : null;
                });
            }
            else
                source = '';
            if (region.indexOf('|') != -1) {
                region = region.substring(0, region.length - 1);
                //divfilter = divfilter + '[data-country="' + country + '"]';
                //console.log(totalitems);
                totalitems = totalitems.filter(function () {
                    var data1 = $(this).data('region');
                    if (data1 != '' && data1 != null) {
                        return data1 ? data1.toString().match(region) : null;
                    }
                });
            }
            else
                region = '';

            if (purpose.indexOf('|') != -1) {
                purpose = purpose.substring(0, purpose.length - 1);
                //divfilter = divfilter + '[data-currency="' + currency + '"]';
                totalitems = totalitems.filter(function () {
                    var data = $(this).data('geo-focus');
                    if (data != '' && data != null) {
                        return data ? data.toString().match(purpose) : null;
                    }
                });

            }
            else
                purpose = '';

            if (investment.indexOf('|') != -1) {
                investment = investment.substring(0, investment.length - 1);
                //divfilter = divfilter + '[data-currency="' + currency + '"]';
                totalitems = totalitems.filter(function () {
                    var data = $(this).data('investment');
                    return data ? data.match(investment) : null;
                });

            }
            else
                investment = '';
            if (share.indexOf('|') != -1) {
                share = share.substring(0, share.length - 1);
                //divfilter = divfilter + '[data-currency="' + currency + '"]';
                totalitems = totalitems.filter(function () {
                    var data = $(this).data('share');
                    return data ? data.match(share) : null;
                });

            }
            else
                share = '';
            if (taxbenfit.indexOf('|') != -1) {
                taxbenfit = taxbenfit.substring(0, taxbenfit.length - 1);
                totalitems = totalitems.filter(function () {
                    var data = $(this).data('currency');
                    if (data != '' && data != null) {
                        return data ? data.toString().match(taxbenfit) : null;
                    }


                });

            }
            else
                taxbenfit = '';



            var cnt = '';
            var currenttab = $('.fundsgridnav li a.active').attr('data-id');
            if (currenttab == 'nav-tablesection') {
                navlist
                    .column(10).search(asset, true, false) //Asset
                    .column(11).search(region, true, false) //Region
                    .column(12).search(newFund, true, false) //NewFund
                    .column(13).search(purpose, true, false) //purpose
                    .column(14).search(toprated, true, false) //toprated*/
                    .column(15).search(taxbenfit, true, false) //TaxBenfit
                    .column(16).search(investment, true, false) //TaxBenfit
                    .column(18).search(source, true, false) //TaxBenfit
                    .column(19).search(FundCode, true, false) //Watchlist
                    .column(21).search(share, true, false) //ShareClass
                    .draw();
                cnt = navlist['context'][0]['aiDisplay'].length / 2;
            }
            else if (currenttab == 'performance-tablesection') {
                perlist
                    .column(12).search(asset, true, false) //Asset
                    .column(13).search(region, true, false) //Region
                    .column(14).search(newFund, true, false) //NewFund
                    .column(15).search(purpose, true, false) //purpose
                    .column(16).search(toprated, true, false) //toprated*/
                    .column(17).search(taxbenfit, true, false) //TaxBenfit
                    .column(18).search(investment, true, false) //TaxBenfit
                    .column(20).search(source, true, false) //TaxBenfit
                    .column(21).search(FundCode, true, false) //Watchlist
                    .column(22).search(share, true, false) //ShareClass
                    .draw();
                cnt = perlist['context'][0]['aiDisplay'].length;
            }
            else if (currenttab == 'dividend-tablesection') {
                devidendlist
                    .column(13).search(asset, true, false) //Asset
                    .column(14).search(region, true, false) //Region
                    .column(15).search(newFund, true, false) //NewFund
                    .column(16).search(purpose, true, false) //purpose
                    .column(17).search(toprated, true, false) //toprated*/
                    .column(18).search(taxbenfit, true, false) //TaxBenfit
                    .column(19).search(investment, true, false) //TaxBenfit
                    .column(21).search(source, true, false) //TaxBenfit
                    .column(22).search(FundCode, true, false) //Watchlist
                    .column(23).search(share, true, false) //ShareClass
                    .draw();
                cnt = devidendlist['context'][0]['aiDisplay'].length;
            }
            else if (currenttab == 'download-tablesection') {
                downloadlist
                    .column(14).search(source, true, false) //TaxBenfit
                    .column(15).search(asset, true, false) //Asset
                    .column(16).search(region, true, false) //Region
                    .column(17).search(taxbenfit, true, false) //TaxBenfit
                    .column(18).search(toprated, true, false) //toprated*/
                    .column(19).search(newFund, true, false) //NewFund
                    .column(20).search(purpose, true, false) //purpose
                    .column(23).search(investment, true, false) //TaxBenfit
                    .column(22).search(FundCode, true, false) //Watchlist
                    .column(24).search(share, true, false) //Watchlist
                    .draw(); //Country
                cnt = downloadlist['context'][0]['aiDisplay'].length;
            }

            if (FundCode != '') {
                $('.dt-checkboxes').addClass('active');
            }
            else { $('.dt-checkboxes').removeClass('active'); }


            var tot = 0;
            if (currenttab == 'nav-tablesection') {
                cnt = navlist['context'][0]['aiDisplay'].length / 2;
                tot = totalNav;
            }
            else if (currenttab == 'performance-tablesection') {
                cnt = perlist['context'][0]['aiDisplay'].length;
                tot = totalPer;
            }
            else if (currenttab == 'dividend-tablesection') {
                cnt = devidendlist['context'][0]['aiDisplay'].length;
                tot = totalPerCal;
            }
            else if (currenttab == 'download-tablesection') {
                cnt = downloadlist['context'][0]['aiDisplay'].length;
                tot = totalDown;
            }
            $('.searchfunds').text('แสดงข้อมูลกองทุน ' + cnt + ' กองจาก ' + tot + ' กอง');
            $('.prod-grid').hide();
            totalitems.show();
            //$('.prod-grid'+divfilter).show();
            if (location.indexOf('#') != -1) {
                $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
            }


        });

        $('.form-control.search-text').on('keyup', function () {
            navlist.search(this.value).draw();
            perlist.search(this.value).draw();
            devidendlist.search(this.value).draw();
            downloadlist.search(this.value).draw();
            var cnt = 0;

            cnt = navlist['context'][0]['aiDisplay'].length / 2;
            var currenttab = $('.fundsgridnav li a.active').attr('data-id');
            var tot = 0;
            if (currenttab == 'nav-tablesection') {
                cnt = navlist['context'][0]['aiDisplay'].length / 2;
                tot = totalNav;
            }
            else if (currenttab == 'performance-tablesection') {
                cnt = perlist['context'][0]['aiDisplay'].length;
                tot = totalPer;
            }
            else if (currenttab == 'dividend-tablesection') {
                cnt = devidendlist['context'][0]['aiDisplay'].length;
                tot = totalPerCal;
            }
            else if (currenttab == 'download-tablesection') {
                cnt = downloadlist['context'][0]['aiDisplay'].length;
                tot = totalDown;
            }
            $('.searchfunds').text('แสดงข้อมูลกองทุน ' + cnt + ' กองจาก ' + tot + ' กอง');
            var txt = this.value;
            $('.prod-grid').hide();
            $('.prod-grid').each(function () {
                if ($(this).find('.fund-name').text().toUpperCase().indexOf(txt.toUpperCase()) != -1) {
                    $(this).show();
                }
            });


            //$('.btn-fundsearch').trigger("click");
        });

        var location = document.location.href;
        //if (location.indexOf('#') != -1) {
        //    var download_id = location.split('#')[1];
        //    if (download_id.indexOf('tablesection') != -1 && download_id == 'download-tablesection') {
        //        $.ajax({
        //            type: "POST",
        //            dataType: 'json',
        //            data: { countryCode: countryCode, InvType: prof, fundPage: pageUrl },
        //            'async': false,
        //            url: '/JSonService/ServicePage.asmx/GetFunds_DownloadsData_LU',
        //            success: function (data) {
        //                downloaddata = data;

        //                console.log(data);
        //                downloadlist.rows.add(data).draw(false);
        //                isfundDownloadloaded = true;
        //                cnt = downloadlist['context'][0]['aiDisplay'].length;
        //                $('.searchfunds').text(cnt + ' funds');
        //                for (i = 0; i <= downloaddata.length; i++) {
        //                    var _fname = downloaddata[i].FundName;
        //                    if (_fname.indexOf('<a ') != -1) {
        //                        _fname = $(_fname).text();
        //                    }
        //                    $(".grid-prod-download").append(
        //                        $('<div class="prod-grid" data-asset="' + downloaddata[i].AssetName + '" data-currency="' + downloaddata[i].CurrencCode + '" data-country="' + downloaddata[i].CountryName
        //                            // + '" data-investment="' + newdata[i].InvestmentCategory 
        //                            + '" data-search="' + downloaddata[i].FundCode + '|' + _fname +
        //                            + '">' +
        //                            '<p>' + downloaddata[i].FundName + '</p>  <hr class="borderstyle">' +
        //                            '<ul class="square">' +
        //                            '<li>' + downloaddata[i].Factsheetname + '</li>' +
        //                            '<li>' + downloaddata[i].KIIDname + '</li>' +
        //                            '<li>' + downloaddata[i].ProspectusName + '</li>' +
        //                            '<li>' + downloaddata[i].MFRname + '</li>' +
        //                            '<li>' + downloaddata[i].SFDRname + '</li>' +
        //                            '<li>' + downloaddata[i].Annualreportname + '</li>' +
        //                            '<li>' + downloaddata[i].SemiAnnualReportname + '</li>' +
        //                            '<li>' + downloaddata[i].PPname + '</li>' +
        //                            '<li>' + downloaddata[i].PSname + '</li>' +
        //                            '<li>' + downloaddata[i].SSname + '</li>' +
        //                            '</ul>' +
        //                            '</div>'

        //                        ));
        //                }
        //                $('.btn-fundsearch').trigger("click");
        //            },
        //            error: function () {
        //            },
        //            complete: function () {
        //                $('#loadtop').hide();
        //            }

        //        });
        //    }
        //}

        //$(document).on('change', '.watchlist', function (e) {
        //    var country = '', asset = '', currency = '', divfilter = '';
        //    $('.styled-checkbox').each(function () {
        //        if (this.checked && $(this).hasClass("asset")) {
        //            asset = asset + $(this).attr('data-value') + '|';
        //        }
        //        if (this.checked && $(this).hasClass("country")) {
        //            country = country + $(this).attr('data-value') + '|';
        //        }
        //        if (this.checked && $(this).hasClass("currency")) {
        //            currency = currency + $(this).attr('data-value') + '|';
        //        }
        //    });
        //    var totalitems = $('.prod-grid');
        //    if (asset.indexOf('|') != -1) {
        //        asset = asset.substring(0, asset.length - 1);
        //        //divfilter = divfilter + '[data-asset="' + asset + '"]';
        //        totalitems = totalitems.filter(function () {
        //            var data = $(this).data('asset');
        //            return data ? data.match(asset) : null;
        //        });
        //    }
        //    else
        //        asset = '';
        //    if (country.indexOf('|') != -1) {
        //        country = country.substring(0, country.length - 1);
        //        //divfilter = divfilter + '[data-country="' + country + '"]';
        //        totalitems = totalitems.filter(function () {
        //            var data = $(this).data('country');
        //            return data ? data.match(country) : null;
        //        });
        //    }
        //    else
        //        country = '';
        //    if (currency.indexOf('|') != -1) {
        //        currency = currency.substring(0, currency.length - 1);
        //        //divfilter = divfilter + '[data-currency="' + currency + '"]';
        //        totalitems = totalitems.filter(function () {
        //            var data = $(this).data('currency');
        //            return data ? data.match(currency) : null;
        //        });

        //    }
        //    else
        //        currency = '';
        //    var val = $('.search-text').val();
        //    if (val.length > 0) {
        //        navlist.search(val).draw();
        //    }



        //    var cnt = '';
        //    var currenttab = $('.fundsgridnav li a.active').attr('data-id');
        //    if (currenttab == 'nav-tablesection') {
        //        var getcookievalue = '';

        //        if (this.checked) {
        //            var name = "watchlistCookie-lu-en=";
        //            var ca = document.cookie.split(';');
        //            for (var i = 0; i < ca.length; i++) {
        //                var c = ca[i];
        //                while (c.charAt(0) == ' ') c = c.substring(1);
        //                if (c.indexOf(name) == 0) getcookievalue = c.substring(name.length, c.length);
        //            }
        //            if (getcookievalue == '') {
        //                getcookievalue = 'defaultvalue';
        //            }
        //        }


        //        navlist
        //            .column(8).search(getcookievalue, true, false) //watch list
        //            .column(2).search(asset, true, false) //Asset
        //            .column(6).search(currency, true, false) //Currency
        //            .column(7).search(country, true, false).draw(); //Country
        //        cnt = navlist['context'][0]['aiDisplay'].length;
        //        if (this.checked == true) {
        //            $('.nav-tablesection .dt-checkboxes').trigger('click');
        //        }
        //    }
        //    else if (currenttab == 'performance-tablesection') {
        //        perlist
        //            .column(11).search(getcookievalue, true, false) //watch list
        //            .column(8).search(asset, true, false) //Asset
        //            .column(9).search(currency, true, false) //Currency
        //            .column(10).search(country, true, false).draw(); //Country
        //        cnt = perlist['context'][0]['aiDisplay'].length;
        //    }
        //    else if (currenttab == 'dividend-tablesection') {
        //        devidendlist
        //            .column(9).search(getcookievalue, true, false) //watch list
        //            .column(6).search(asset, true, false) //Asset
        //            .column(7).search(currency, true, false) //Currency
        //            .column(8).search(country, true, false).draw(); //Country
        //        cnt = devidendlist['context'][0]['aiDisplay'].length;
        //    }
        //    else if (currenttab == 'download-tablesection') {
        //        downloadlist
        //            .column(0).search(getcookievalue, true, false) //watch list
        //            .column(7).search(asset, true, false) //Asset
        //            .column(8).search(currency, true, false) //Currency
        //            .column(9).search(country, true, false).draw(); //Country
        //        cnt = downloadlist['context'][0]['aiDisplay'].length;
        //    }
        //    //$($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
        //    $('.searchfunds').text(cnt + ' funds');
        //    $('.prod-grid').hide();
        //    totalitems.show();
        //    //$('.prod-grid'+divfilter).show();

        //});



        $('.fundsgridnav li a').click(function () {
            //$('#loadtop').show();
            $('.tablesection').hide();
            //console.log('loader');
            /*$('#loadtop-funds').show();*/
            var id = $(this).attr('data-id');
            $('.' + id).show();
            $('.fundsgridnav li a').removeClass('active');
            $(this).addClass('active');

            $('.default--link').hide();
            if (id == 'nav-tablesection') {
                $('.down-nav').show();
            }
            else if (id == 'performance-tablesection') {
                $('.down-per').show();
            }
            else if (id == 'dividend-tablesection') {
                $('.down-per-cal').show();
            }
            else if (id == 'download-tablesection') {
                $('.down-download').show();
            }

            if (id == 'download-tablesection' && isfundDownloadloaded == false) {
                $('#loadtop-funds').show();
                setTimeout(function () {
                    var token = $('input[name="__RequestVerificationToken"]').val();
                    var tarurl = window.location.pathname + "/GetFunds_DownloadsData";
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        'async': false,
                        data: { __RequestVerificationToken: token },
                        url: tarurl,
                        ////url: '/api/FundsApi/GetFunds_DownloadsData?__RequestVerificationToken=' + token,
                        success: function (data) {
                            downloaddata = data;
                            // console.log(data);
                            downloadlist.rows.add(data).draw(false);
                            isfundDownloadloaded = true;
                            var cnt = downloadlist['context'][0]['aiDisplay'].length;
                            $('.searchfunds').text('แสดงข้อมูลกองทุน ' + cnt + ' กองจาก ' + totalDown + ' กอง');
                            for (i = 0; i <= downloaddata.length; i++) {
                                if (downloaddata[i] != undefined) {
                                    var _fname = downloaddata[i].FundName;
                                    if (_fname.indexOf('<a ') != -1) {
                                        _fname = $(_fname).text();
                                    }
                                    $(".grid-prod-download").append(
                                        //
                                        $('<div class="prod-grid" data-fundcode=' + downloaddata[i].FundCode + ' data-fundname=' + downloaddata[i].FundName + ' data-source=' + downloaddata[i].Source + ' data-region=' + downloaddata[i].Region + ' data-purpose=' + downloaddata[i].Purpose + ' data-taxbenfit=' + downloaddata[i].TaxBenfit + ' data-newfund=' + downloaddata[i].NewFund + ' data-toprated=' + downloaddata[i].TopRated + ' data-keywords=' + downloaddata[i].Keywords + ' data-investmentcategory=' + downloaddata[i].InvestmentCategory + ' data-investment=' + downloaddata[i].InvestmentCategory + ' data-share=' + downloaddata[i].ShareClass + '>' +
                                            '<p class="fund-name" data-search="' + downloaddata[i].FundCode + '"> <a href = "/funds/mutual-funds/funddetails?fundcode=' + downloaddata[i].FundCode + '">' + downloaddata[i].FundName + '</a ></p>  <hr class="borderstyle">' +
                                            '<ul class="square">' +
                                            '<li>' + downloaddata[i].Factsheetname + '</li>' +
                                            '<li>' + downloaddata[i].MasterFactsheetname + '</li>' +
                                            '<li>' + downloaddata[i].Portfolio + '</li>' +
                                            '<li>' + downloaddata[i].Prospectus + '</li>' +
                                            '<li>' + downloaddata[i].QA + '</li>' +
                                            '<li>' + downloaddata[i].FundInsight + '</li>' +
                                            '<li>' + downloaddata[i].HalfYearReport + '</li>' +
                                            '<li>' + downloaddata[i].AnnualReport + '</li>' +
                                            '<li>' + downloaddata[i].InvestmentReport + '</li>' +
                                            '<li>' + downloaddata[i].FixDebtReport + '</li>' +
                                            '<li>' + downloaddata[i].MonthlyReport + '</li>' +
                                            '<li>' + downloaddata[i].OnePageSnapshot + '</li>' +
                                            '</ul>' +
                                            '</div>'

                                        ));
                                }
                            }
                            $('#loadtop-funds').hide();
                            /*$('.btn-fundsearch').trigger("click");*/
                            $('#downtablegrid .dt-checkboxes').click(function () {
                                if ($(this).hasClass('active')) {
                                    $(this).removeClass('active');
                                }
                                else {
                                    $(this).addClass('active');
                                }
                            });
                        },
                        error: function () {
                            $('#loadtop-funds').hide();
                        },
                        complete: function () {
                            $('#loadtop-funds').hide();
                        }

                    });
                }, 500);

            }
            else {
                //console.log('other');
                $('#loadtop-funds').hide();
            }
            $('.btn-fundsearch').trigger("click");
            $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
        });
        $('#showdiv1').click(function () {
            $('.gridtable').hide();
            $('.listtable').show();
            $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
        });
        var navgrid = false, pergrid = false, devgrid = false, downloadgrid = false;
        $('#showdiv2').click(function () {
            var tabId = $('.fundsgridnav ul li a.active').attr('data-id');
            $('.gridtable').show();
            $('.listtable').hide();
        });
        $('.fund-reset').click(function () {
            $(".styled-checkbox").prop("checked", false);
            $('.search-text').val('')
            $('.btn-fundsearch').trigger("click");
        });
    }
});

$(function () {
    $('.sm-none.listandgrid a').click(function () {
        $('.sm-none.listandgrid a').removeClass('active');
        $('.sm-none.listandgrid a img').removeClass('opcityfull');
        $(this).addClass('active');
        $(this).find('img').addClass('opcityfull');
        // $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
    });
});
//$(window).scroll(function () {
//    var window_top = $(window).scrollTop();
//    $('.header-template').width();
//    var div_top = $('#sticky-anchor').offset().top;
//    if (window_top > div_top) {
//        $('#search-template').addClass('stickfund');
//    } else {
//        $('#search-template').removeClass('stickfund');
//    }
//    var div_top = $('.sticky-anchor-head-nav').offset().top;
//    if (window_top > div_top) {
//        $('.header-template-nav').addClass('stickfundhead');
//    } else {
//        $('.header-template-nav').removeClass('stickfundhead');
//    }


//    var div_top_per = $('.sticky-anchor-head-per').offset().top;
//    if (window_top > div_top_per) {
//        $('.header-template-per').addClass('stickfundhead');
//    } else {
//        $('.header-template-per').removeClass('stickfundhead');
//    }
//    var div_top_dev = $('.sticky-anchor-head-dev').offset().top;
//    if (window_top > div_top_dev) {
//        $('.header-template-dev').addClass('stickfundhead');
//    } else {
//        $('.header-template-dev').removeClass('stickfundhead');
//    }

//    var div_top_down = $('.sticky-anchor-head-down').offset().top;
//    if (window_top > div_top_down) {
//        $('.header-template-down').addClass('stickfundhead');
//    } else {
//        $('.header-template-down').removeClass('stickfundhead');
//    }
//});




//$(window).scroll(function () {
//    var sticky = $('.tablesection thead');
//    var scroll = $(window).scrollTop();
//    var offsetheight = $('.tablesection').offset().top - $('.head-desk').height() - $('.search-datatable-data').height();
//    var headerHeight = $('.head-desk').height();
//    var searchheight = $('.search-datatable-data').height();
//    if (scroll >= offsetheight) {
//        $('.tablesection thead').addClass('navfixed');
//        $('.search-datatable-data').addClass('navfixed1');
//        $('.fundsfilterblock ').addClass('navfixed');
//        $('.navfixed').css("top", headerHeight + searchheight + 128);
//        $('.navfixed1').css("top", headerHeight + searchheight);
//        //$($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();

//    } else {

//        $('.tablesection thead').removeClass('navfixed');
//        $('.search-datatable-data').removeClass('navfixed1');
//        $('.navfixed').css("top", " ");
//        $('.navfixed1').css("top", " ");
//    }

//});


$(document).ready(function () {
    setTimeout(function () {
        var token = $('input[name="__RequestVerificationToken"]').val();
        $(".down-nav").click(function (e) {
            e.preventDefault();
            $.ajax({
                type: "Post",
                data: { __RequestVerificationToken: token },
                url: '/funds/mutual-funds/ExportToExcelNAVData',
                success: function (data, status, xhr) {
                    // Create a blob from the response data
                    var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = url;
                    a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                },
                error: function () {
                    // Handle errors
                }
            });
        });
        $(".down-per").click(function (e) {
            e.preventDefault();
            var tarurl = window.location.pathname + '/ExportToExcelChartperformence';
            $.ajax({
                type: "Post",
                url: tarurl,
                data: { __RequestVerificationToken: token },
                success: function (data, status, xhr) {
                    var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = url;
                    a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                },
                error: function () {
                    // Handle errors
                }
            });
        });
        $(".down-per-cal").click(function (e) {
            e.preventDefault();
            $.ajax({
                type: "Post",
                data: { __RequestVerificationToken: token },
                url: '/funds/mutual-funds/ExportToExcelChartPerformanceCalendarYear',
                success: function (data, status, xhr) {
                    var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = url;
                    a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                },
                error: function () {
                    // Handle errors
                }
            });
        });
        function downloadexcel(data) {
            //var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
            var blob = data;
            // Create a temporary link and trigger a click event to download the file
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        }
        // $(".down-nav").attr("href", "/api/FundsApi/ExportToExcelNAVData?__RequestVerificationToken=" + token);
        // $(".down-per").attr("href", "/api/FundsApi/ExportToExcelChartperformence?__RequestVerificationToken=" + token);
        // $(".down-per-cal").attr("href", "/api/FundsApi/ExportToExcelChartPerformanceCalendarYear?__RequestVerificationToken=" + token);
    }, 500); // 3000 milliseconds = 3 seconds

    if ($('#tablegridsearch').length > -1) {
        $("#loadtop-funds").hide();
        var searchlist = $('#tablegridsearch').DataTable({
            dom: 'rtp',
            order: false,
            scrollX: true,
            fixedHeader: true,
            searching: true,
            caseInsensitive: false,
            columns: [
                { 'targets': 0, 'data': 'FundCode', visible: false },
                { 'targets': 1, 'data': 'FundNameOld', visible: false },
                { 'targets': 2, data: 'FundCodeOld' },
                { 'targets': 3, data: 'FundCodeNew' },
                { 'targets': 4, data: 'FundNameOld' },
                { 'targets': 5, data: 'FundNameNew' },
                { 'targets': 6, data: 'FundNameOld_EN' },
                { 'targets': 7, data: 'FundNameNew_EN' },
            ],
            oLanguage: {
                sInfoFiltered: ""
            },
            fixedColumns: {
                leftColumns: 2
            },
            scroller: {
                loadingIndicator: true
            },
            info: true,
            scrollCollapse: true,
            paging: false,
            scrollCollapse: true,
            scrollY: '200vh',
        });
        $(document).on('click', '.btn-fundsearch', function (e) {

            searchlist.CaseSensitive = false;
            var val = $('.search-text').val();
            if (val.length > 0) {
                searchlist.search(val).draw();
            }
            else {
                val = "";
                searchlist.search(val).draw();
            }
        });
        $('.form-control.search-text').on('keyup', function () {
            $(".btn-fundsearch")[0].click();
        })
        $("#loadtop-funds").hide();
    }
});
